import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Fade } from "react-awesome-reveal";
import { IReviewTitle, ITestimonialData } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";

const Tesimonial = (props: {
  testimonial: ITestimonialData[];
  reviewTitle: IReviewTitle[];
}) => {
  const mobile = useMobile();

  const infos = props.testimonial?.map((data) => {
    return {
      id: data?.id,
      name: data?.name,
      title: data?.title,
      date: data?.date,
      description: data?.description,
      photo: data?.photo[0]?.media?.url,
    };
  });
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-219e7380 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="219e7380"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div
          className="elementor-container elementor-column-gap-default"
          style={{ maxWidth: "unset" }}
        >
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7de54844"
              data-id="7de54844"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap custom-elementor-title">
                  <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-50ffc532 elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="50ffc532"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          {props?.reviewTitle[0]?.title}
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-21afe521 elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="21afe521"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h5
                          className="elementor-heading-title elementor-size-default"
                          dangerouslySetInnerHTML={{
                            __html: props?.reviewTitle[0]?.sub_title,
                          }}
                        />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Fade direction="up" triggerOnce={true}>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f7f6784 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="f7f6784"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched","animation":"fadeInUp","animation_delay":400,"background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fd82c5d"
                data-id="fd82c5d"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-ba6fac8 elementor-widget elementor-widget-hoteller-slider-horizontal"
                      data-id="ba6fac8"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="hoteller-slider-horizontal.default"
                    >
                      <div className="elementor-widget-container">
                        <div
                          className="tg_horizontal_slider_wrapper"
                          data-autoplay="0"
                          data-loop="0"
                          data-navigation="0"
                          data-pagination="0"
                          data-fullscreen="0"
                          style={{ height: mobile ? "700px" : "80dvh" }}
                        >
                          <Swiper
                            modules={[Navigation]}
                            slidesPerView={1}
                            navigation
                            // spaceBetween={10}
                            grabCursor={true}
                            style={{
                              height: "100%",
                            }}
                          >
                            {infos?.map((info, index) => {
                              return (
                                <SwiperSlide key={index}>
                                  <div
                                    style={{
                                      position: "relative",
                                      height: "100%",
                                      // backgroundImage: `url(${image?.image})`,
                                      // backgroundRepeat: "no-repeat",
                                      // backgroundSize: "cover",
                                      // backgroundPosition: "center",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      className="custom-tesimonial-text"
                                      style={{
                                        position: "absolute",
                                        textAlign: "center",
                                        // transform: "translate(-50%, -50%)",
                                        zIndex: 2,
                                        padding: "0px 150px",
                                      }}
                                    >
                                      {info?.photo && (
                                        <img
                                          src={`${process.env.REACT_APP_cmsUrl}${info?.photo}`}
                                          alt="Customer"
                                          style={{
                                            display: "unset",
                                            width: "150px",
                                            height: "150px",
                                            marginBottom: "10px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                      <h2
                                        style={{
                                          color: "#ffffff",
                                          fontSize: "30px",
                                          lineHeight: "1em",
                                        }}
                                      >
                                        {info?.name}
                                        {info?.date &&
                                          `, ${new Date(
                                            info.date,
                                          ).toLocaleString("en-US", {
                                            month: "short",
                                            year: "numeric",
                                          })}`}
                                      </h2>
                                      <h3
                                        className="custom-tesimonial-h3"
                                        style={{
                                          color: "#ffffff",
                                          fontSize: "25px",
                                          paddingTop: "0.5em",
                                          lineHeight: "1.2em",
                                        }}
                                      >
                                        {info?.title}
                                      </h3>
                                      <p
                                        style={{
                                          color: "#ffffff",
                                          paddingTop: "3em",
                                          paddingBottom: "1em",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: info?.description,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fade>
    </>
  );
};

export default Tesimonial;
